export default __webpack_public_path__ + "static/media/inProgress.70576fea.svg";